import { styled } from '@linaria/react';

export const Container = styled.div<{ checked: boolean }>`
	display: flex;
	width: 16px;
	height: 16px;
	background-color: ${({ checked }) =>
		checked ? 'var(--color-white)' : 'transparent'};
	border: 1px solid var(--color-white);
	border-radius: 4px;

	svg {
		margin: auto;
	}
`;
